import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'ver-mais',
    templateUrl: 'ver-mais.dialog.html',
    styles: [``]
})
export class VerMaisDialog implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<VerMaisDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.title = data.title;
        this.text = data.text;
    }
    @Input()
    text: string;
    @Input()
    title: string;
    ngOnInit(): void { }


    onNoClick(): void {
        this.dialogRef.close(null);
      }
      onOkClick(){
        this.dialogRef.close('ok');
      }
  

}
